export const PRINT_HIDDEN_ATTR = 'data-print-hidden';
export const EXPORT_PRINT_HIDDEN_ATTR = 'data-export-print-hidden';
